<script lang="ts">
    import { fly } from "svelte/transition";
    import { LL } from "../../../i18n/i18n-svelte";
    import { isDescriptionActiveStore } from "../../Stores/SilentStore";
    import { triggerClickOnEnterOrSpace } from "../../Utils/svelte-a11y";
</script>

<!-- Use "showMobileInformation" to restrict the visibility for the mobile experience -->
<div
    class="w-full absolute @xl:top-[90px]
        z-0 text-white border border-solid
        border-danger flex flex-col items-center justify-between bg-no-repeat bg-center
        bg-danger-1000/70 backdrop-blur rounded-lg text-center max-w-[230px]
        translate-x-[-16px] mobile:translate-x-[-52px] top-[60px]"
    transition:fly={{ y: 30, duration: 400 }}
    role="button"
    tabindex="0"
    aria-expanded={$isDescriptionActiveStore}
    aria-label={$LL.camera.my.silentZone()}
    onclick={(event) => {
        event.stopPropagation();
        event.preventDefault();
        isDescriptionActiveStore.set(!$isDescriptionActiveStore);
    }}
    onkeydown={triggerClickOnEnterOrSpace}
>
    <div class="py-1 px-1">
        <div class="m-0 text-center text-sm bold">
            {$LL.camera.my.silentZone()}
        </div>
        {#if $isDescriptionActiveStore}
            <div class="text-danger-400 text-xxs">
                {$LL.camera.my.silentZoneDesc()}
            </div>
        {/if}
    </div>
</div>
